import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { BlogCreate, BlogDetails, BlogDraftCreate, BlogEntity, BlogUpdate } from '@repo/types';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlogApiService extends BaseApi<BlogEntity, BlogCreate, BlogUpdate> {
  constructor() {
    super('/Blog', {
      get: '/AdminPanel/GetBlogs',
      post: '/AdminPanel/AddBlog',
    });
  }
  getAllBlogs<T = BlogEntity>() {
    let queryParams = `?Pagination.Page=1&Pagination.AmountOfListPerPage=999999`;
    return http$.get<{ dataWithPagination: { data: T[]; } }>(`${this.endpoint.get}${queryParams}`).pipe(map((i) => i.dataWithPagination.data));
  }
  override create<T = BlogEntity>(model: BlogCreate) {
    return http$.post<T>('/AdminPanel/AddBlog', model);
  }

  updateBlog(model: BlogUpdate) {
    console.log(model);
    return http$.patch<never>('/AdminPanel/EditBlog', model);
  }

  saveDraft(model: BlogDraftCreate) {
    console.log('Saving draft:', model);
    return http$.post<never>('/AdminPanel/SaveDraft', model);
  }

  deleteBlog(id: number) {
    return http$.delete<never>('/AdminPanel/DeleteBlog', { body: { id: id } });
  }

  getBlogDetail(id: number) {
    return http$.get<{ blog: BlogDetails }>(`/AdminPanel/GetBlog?Id=${id}`);
  }

  deleteDraft(id: number) {
    return http$.delete<never>('/AdminPanel/DeleteDraft', { body: { id: id } });
  }
}

